import { ProductPriceDto } from "@insite/client-framework/Types/ApiModels";

/**
 * A sale price set in the admin console (BasicSalePrice) only reaches the scalar fields of a pricing
 * result: `isOnSale`, `actualPrice` and `actualPriceDisplay`. Every break-price array, including
 * `actualBreakPrices`, still carries the regular price-matrix prices, so anything that resolves a price
 * through the break arrays (the client-framework ProductPriceService helpers) never sees the sale.
 * These helpers give the one sale price that applies at every quantity break, or nothing when the
 * product is not on sale.
 */

/** The sale price display when the product is on sale, otherwise undefined. */
export const getSalePriceDisplay = (pricing: ProductPriceDto | null | undefined): string | undefined =>
    pricing?.isOnSale && pricing.actualPriceDisplay ? pricing.actualPriceDisplay : undefined;

/** The sale price when the product is on sale, otherwise undefined. */
export const getSalePrice = (pricing: ProductPriceDto | null | undefined): number | undefined =>
    pricing?.isOnSale && pricing.actualPriceDisplay ? pricing.actualPrice : undefined;
